interface TextProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  className?: string;
}

export const Text: React.FC<TextProps> = ({
  children,
  className = "",
  ...rest
}) => {
  const textStyle = "text-black text-2xl font-normal";
  return (
    <p className={`${textStyle} ${className}`} {...rest}>
      {children}
    </p>
  );
};
